var map = {
	"./icon-add.svg": "./src/icons/svg/icon-add.svg",
	"./icon-admin.svg": "./src/icons/svg/icon-admin.svg",
	"./icon-back.svg": "./src/icons/svg/icon-back.svg",
	"./icon-back2.svg": "./src/icons/svg/icon-back2.svg",
	"./icon-beian.svg": "./src/icons/svg/icon-beian.svg",
	"./icon-ben.svg": "./src/icons/svg/icon-ben.svg",
	"./icon-bianji.svg": "./src/icons/svg/icon-bianji.svg",
	"./icon-camera.svg": "./src/icons/svg/icon-camera.svg",
	"./icon-camera1.svg": "./src/icons/svg/icon-camera1.svg",
	"./icon-cardr.svg": "./src/icons/svg/icon-cardr.svg",
	"./icon-chouqu.svg": "./src/icons/svg/icon-chouqu.svg",
	"./icon-close.svg": "./src/icons/svg/icon-close.svg",
	"./icon-closeeye.svg": "./src/icons/svg/icon-closeeye.svg",
	"./icon-code.svg": "./src/icons/svg/icon-code.svg",
	"./icon-config.svg": "./src/icons/svg/icon-config.svg",
	"./icon-createTime.svg": "./src/icons/svg/icon-createTime.svg",
	"./icon-dangdifill.svg": "./src/icons/svg/icon-dangdifill.svg",
	"./icon-daohang.svg": "./src/icons/svg/icon-daohang.svg",
	"./icon-delete.svg": "./src/icons/svg/icon-delete.svg",
	"./icon-ding.svg": "./src/icons/svg/icon-ding.svg",
	"./icon-duanxin.svg": "./src/icons/svg/icon-duanxin.svg",
	"./icon-edit.svg": "./src/icons/svg/icon-edit.svg",
	"./icon-editor.svg": "./src/icons/svg/icon-editor.svg",
	"./icon-fengxian.svg": "./src/icons/svg/icon-fengxian.svg",
	"./icon-fuwu.svg": "./src/icons/svg/icon-fuwu.svg",
	"./icon-geren.svg": "./src/icons/svg/icon-geren.svg",
	"./icon-guanli.svg": "./src/icons/svg/icon-guanli.svg",
	"./icon-guocheng.svg": "./src/icons/svg/icon-guocheng.svg",
	"./icon-hebi-cailiao.svg": "./src/icons/svg/icon-hebi-cailiao.svg",
	"./icon-hebi-celiang.svg": "./src/icons/svg/icon-hebi-celiang.svg",
	"./icon-hebi-chezhu.svg": "./src/icons/svg/icon-hebi-chezhu.svg",
	"./icon-hebi-gongcheng.svg": "./src/icons/svg/icon-hebi-gongcheng.svg",
	"./icon-hebi-gongju.svg": "./src/icons/svg/icon-hebi-gongju.svg",
	"./icon-hebi-jiankong.svg": "./src/icons/svg/icon-hebi-jiankong.svg",
	"./icon-hebi-jiaoyu.svg": "./src/icons/svg/icon-hebi-jiaoyu.svg",
	"./icon-hebi-rili.svg": "./src/icons/svg/icon-hebi-rili.svg",
	"./icon-hebi-shenhe.svg": "./src/icons/svg/icon-hebi-shenhe.svg",
	"./icon-hebi-wenben.svg": "./src/icons/svg/icon-hebi-wenben.svg",
	"./icon-hebi-zhaungji.svg": "./src/icons/svg/icon-hebi-zhaungji.svg",
	"./icon-hebi-zhiliang.svg": "./src/icons/svg/icon-hebi-zhiliang.svg",
	"./icon-hebi-zhongjie.svg": "./src/icons/svg/icon-hebi-zhongjie.svg",
	"./icon-huodong.svg": "./src/icons/svg/icon-huodong.svg",
	"./icon-jianguan.svg": "./src/icons/svg/icon-jianguan.svg",
	"./icon-jiesuo.svg": "./src/icons/svg/icon-jiesuo.svg",
	"./icon-laiyuan.svg": "./src/icons/svg/icon-laiyuan.svg",
	"./icon-log.svg": "./src/icons/svg/icon-log.svg",
	"./icon-menu.svg": "./src/icons/svg/icon-menu.svg",
	"./icon-more.svg": "./src/icons/svg/icon-more.svg",
	"./icon-mudedi.svg": "./src/icons/svg/icon-mudedi.svg",
	"./icon-open.svg": "./src/icons/svg/icon-open.svg",
	"./icon-openeye.svg": "./src/icons/svg/icon-openeye.svg",
	"./icon-oss.svg": "./src/icons/svg/icon-oss.svg",
	"./icon-pinglun.svg": "./src/icons/svg/icon-pinglun.svg",
	"./icon-pingwei.svg": "./src/icons/svg/icon-pingwei.svg",
	"./icon-platform.svg": "./src/icons/svg/icon-platform.svg",
	"./icon-platform1.svg": "./src/icons/svg/icon-platform1.svg",
	"./icon-project.svg": "./src/icons/svg/icon-project.svg",
	"./icon-renyuan.svg": "./src/icons/svg/icon-renyuan.svg",
	"./icon-role.svg": "./src/icons/svg/icon-role.svg",
	"./icon-rt.svg": "./src/icons/svg/icon-rt.svg",
	"./icon-shanchu.svg": "./src/icons/svg/icon-shanchu.svg",
	"./icon-shanchu1.svg": "./src/icons/svg/icon-shanchu1.svg",
	"./icon-shang.svg": "./src/icons/svg/icon-shang.svg",
	"./icon-shezhi.svg": "./src/icons/svg/icon-shezhi.svg",
	"./icon-shoucang.svg": "./src/icons/svg/icon-shoucang.svg",
	"./icon-shoucangfill.svg": "./src/icons/svg/icon-shoucangfill.svg",
	"./icon-shouye.svg": "./src/icons/svg/icon-shouye.svg",
	"./icon-shouye1.svg": "./src/icons/svg/icon-shouye1.svg",
	"./icon-sousuo.svg": "./src/icons/svg/icon-sousuo.svg",
	"./icon-sql.svg": "./src/icons/svg/icon-sql.svg",
	"./icon-submitTime.svg": "./src/icons/svg/icon-submitTime.svg",
	"./icon-suoding.svg": "./src/icons/svg/icon-suoding.svg",
	"./icon-system.svg": "./src/icons/svg/icon-system.svg",
	"./icon-time.svg": "./src/icons/svg/icon-time.svg",
	"./icon-tishi.svg": "./src/icons/svg/icon-tishi.svg",
	"./icon-tixing.svg": "./src/icons/svg/icon-tixing.svg",
	"./icon-toubiaoren.svg": "./src/icons/svg/icon-toubiaoren.svg",
	"./icon-tousu.svg": "./src/icons/svg/icon-tousu.svg",
	"./icon-tubiao.svg": "./src/icons/svg/icon-tubiao.svg",
	"./icon-upload.svg": "./src/icons/svg/icon-upload.svg",
	"./icon-user.svg": "./src/icons/svg/icon-user.svg",
	"./icon-users.svg": "./src/icons/svg/icon-users.svg",
	"./icon-w.svg": "./src/icons/svg/icon-w.svg",
	"./icon-xia.svg": "./src/icons/svg/icon-xia.svg",
	"./icon-xiangmu.svg": "./src/icons/svg/icon-xiangmu.svg",
	"./icon-xiangqu.svg": "./src/icons/svg/icon-xiangqu.svg",
	"./icon-xiangqufill.svg": "./src/icons/svg/icon-xiangqufill.svg",
	"./icon-yin.svg": "./src/icons/svg/icon-yin.svg",
	"./icon-yujing.svg": "./src/icons/svg/icon-yujing.svg",
	"./icon-zhaobiaoagent.svg": "./src/icons/svg/icon-zhaobiaoagent.svg",
	"./icon-zhaobiaoren.svg": "./src/icons/svg/icon-zhaobiaoren.svg",
	"./icon-zhedie.svg": "./src/icons/svg/icon-zhedie.svg",
	"./icon-zonghe.svg": "./src/icons/svg/icon-zonghe.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync recursive \\.svg$";